import React, { useEffect, useState } from "react";
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import {
    Box, Stack, Modal, AppBar, Toolbar, IconButton, Typography, Divider, TextField, Badge, Paper, Menu, Popper, FormControl, FormLabel, TextareaAutosize,
    ClickAwayListener, Avatar
} from '@mui/material';
import { LoadingButton, } from '@mui/lab';
import Tooltip from '@mui/material/Tooltip';
// components
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// icon
import { Icon } from '@iconify/react';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { PickersDay } from '@mui/x-date-pickers';
import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';
import Iconify from '../../components/Iconify';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import AppCache from '../../services/AppCache';
import URLS from '../../services/urls.service';
import DashBoardMenuService from '../../services/dashBoardMenu.service';
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Moment from 'moment';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 50;
// const APPBAR_MOBILE = 64;
// const APPBAR_DESKTOP = 92;
const APPBAR_DESKTOP = 50;

const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    // background: alpha(theme.palette.primary.light, 0.20),
    // background: alpha(theme.palette.cyan.dark, 0.5),
    // background: '#fbe9e7',
    background: '#FFFFFF',
    borderBottom: `1px solid #E5E7EB`
    // background: '#723D46',
    // backgroundColor: alpha(theme.palette.background.default, 0.72),

}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('sm')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 2),
    },
}));
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '75vh',
    overflow: 'auto',
    borderRadius: '8px',
};
const CelebrationBadge = ({ type }) => {

    const normalizedType = (type || "").toLowerCase();

    const badgeConfig = {
        birthday: {
            label: "🎉 Birthday",
            bg: "#FFF0E6",
            color: "#E85D04",
        },
        anniversary: {
            label: "🏆 Anniversary",
            bg: "#FFF5D6",
            color: "#B77900",
        },
        wedding: {
            label: "💍 Wedding",
            bg: "#F3E8FF",
            color: "#9333EA",
        },
        "special event": {
            label: "🎊 Special Event",
            bg: "#E0F2FE",
            color: "#0284C7",
        },
    };

    const config = badgeConfig[normalizedType] || {
        label: type || "Event",
        bg: "#E8F0FE",
        color: "#2563EB",
    };

    return (
        <Box
            component="span"
            sx={{
                px: 1,
                py: 0.25,
                borderRadius: "12px",
                bgcolor: config.bg,
                color: config.color,
                fontSize: 10,
                fontWeight: 500,
                whiteSpace: "nowrap",
            }}
        >
            {config.label}
        </Box>
    );
};
const getDefaultMessage = (item) => {
    const name = item.name || item.ExecutiveName || "";
    const type = (item.type || item.EventName || "").toLowerCase();

    switch (type) {
        case "birthday":
        case "birth day":
            return `Happy Birthday ${name}!`;

        case "baby":
            return "Congratulations on the arrival of your little one!";

        case "anniversary":
            return name
                ? `Congratulations ${name} on Your Work Anniversary!`
                : "Happy Work Anniversary!";

        case "wedding":
            return `Congratulations ${name} on Your Wedding!`;

        default:
            return name
                ? `Congratulations!`
                : "Congratulations!";
    }
};

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
    onOpenSidebar: PropTypes.func,
};
const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function DashboardNavbar({ onOpenSidebar, openNav, dwidth, acknowledgeData }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [username, setDashboardusername] = useState([]);
    const [userId, setUserId] = useState([]);
    const [mark, setMark] = useState(false);
    const [isSaplUser, setIsSaplUser] = useState(false);
    const [date, setDate] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(() => startOfMonth(new Date()));
    const [attendanceData, setAttendanceData] = useState([]);

    const [anchorEl, setAnchorEl] = useState(null);
    const openDateBox = Boolean(anchorEl);
    const [open, setOpen] = useState(false);

    const [notificationAnchor, setNotificationAnchor] = useState(null)

    const openAcknowledgeList = Boolean(notificationAnchor)
    const [acknowledgeModal, setAcknowledgeModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [tentativeDate, setTentativeDate] = useState('');
    const [tentativeTime, setTentativeTime] = useState("");
    const [timeRequrired, setTimeRequrired] = useState("");
    const [remark, setRemark] = useState("");

    const [eventAnchor, setEventAnchor] = useState(null);
    const openCelebrations = Boolean(eventAnchor);

    const [eventData, setEventData] = useState([]);
    const [wishModalOpen, setWishModalOpen] = useState(false);
    const [wishItems, setWishItems] = useState([]);
    const [wishMessages, setWishMessages] = useState({});
    const [selectedWishIds, setSelectedWishIds] = useState([]);
    const [sending, setSending] = useState(false);

    const [wishResponses, setWishResponses] = useState({});

    const [celebrationTab, setCelebrationTab] = useState("today"); // "today" | "wishes"
    const [wishesForMe, setWishesForMe] = useState([]);

    const safeString = (value) =>
        typeof value === "string" ? value.trim() : "";

    const normalizeName = (name) =>
        safeString(name)
            .split("-")[0]
            .trim()
            .toLowerCase();

    const safeEventData = Array.isArray(eventData) ? eventData : [];

    const myName = safeString(CurrentLoggedInUser?.ExecutiveName);
    const myFirstName = myName.split(/\s+/)[0] || "";

    const myEvent = safeEventData.find((item) =>
        normalizeName(item?.ExecutiveName).startsWith(normalizeName(myName))
    );

    const isMyBirthday = safeEventData.some((item) =>
        safeString(item?.EventName).toLowerCase().includes("birth") &&
        normalizeName(item?.ExecutiveName) === normalizeName(myName) &&
        item?.EventDate &&
        Moment(item.EventDate).isValid() &&
        Moment(item.EventDate).isSame(Moment(), "day")
    );

    const showWishesTab = isMyBirthday || wishesForMe.length > 0;

    const isMyEvent = (item) => {
        const eventName = normalizeName(
            item?.ExecutiveName || item?.name
        );
        const currentName = normalizeName(myName);

        return Boolean(eventName && currentName) &&
            (
                eventName === currentName ||
                eventName.split(/\s+/)[0] === currentName.split(/\s+/)[0]
            );
    };

    const hideWishButton =
        safeEventData.length === 1 && isMyEvent(safeEventData[0]);


    const mapWishItem = (item = {}) => {
        const eventName = safeString(item.EventName).toLowerCase();

        let type = "event";

        if (eventName.includes("birth")) {
            type = "birthday";
        } else if (eventName.includes("anniversary")) {
            type = "anniversary";
        } else if (eventName.includes("wedding")) {
            type = "wedding";
        } else if (eventName.includes("baby")) {
            type = "baby";
        } else if (eventName === "special event") {
            type = "special event";
        }

        return {
            id: item.EventId ?? null,
            name: safeString(item.ExecutiveName) ||
                safeString(item.EventTitle) ||
                "Celebration",
            team: safeString(item.Department),
            type,
            years: null,
            message: safeString(item.EventMessage),
            isAllowRespond: Boolean(item.IsAllowRespond),
            responseId: item.ResponseId ?? null,
        };
    };

    const openWishModal = (items) => {
        const mappedItems = (Array.isArray(items) ? items : [])
            .filter((item) => item?.EventId != null)
            .map(mapWishItem);

        if (mappedItems.length === 0) {
            enqueueSnackbar("No valid celebrations found.", {
                variant: "info",
            });
            return;
        }

        setWishItems(mappedItems);
        setSelectedWishIds([]);
        setWishResponses({});
        handleCelebrationClose();
        setWishModalOpen(true);
    };
    // Individual wish
    const handleWish = (item) => {
        openWishModal([item]);
    };
    const wishable = (Array.isArray(eventData) ? eventData : []).filter(
        (e) =>
            e.IsAllowRespond &&
            normalizeName(e.ExecutiveName) !== normalizeName(myName)
    );

    const allWished = wishable.length > 0 && wishable.every((e) => Boolean(e.ResponseId));
    //const allWished =
    //    eventData.filter((item) => item.IsAllowRespond).length > 0 &&
    //    eventData
    //        .filter((item) => item.IsAllowRespond)
    //        .every((item) => Boolean(item.ResponseId));

    // Wish All
    const handleWishAll = () => {
        const eligibleItems = wishable.filter((e) => !e.ResponseId);
        if (eligibleItems.length === 0) {
            enqueueSnackbar("No pending wishes to send.", { variant: "info" });
            return;
        }
        openWishModal(eligibleItems);
    };
    const handleWishModalClose = () => setWishModalOpen(false);

    const handleToggleSelect = (id) => {
        setSelectedWishIds((prev) =>
            prev.includes(id)
                ? prev.filter((x) => x !== id)
                : [...prev, id]
        );
    };


    const handleWishReset = () => {
        //setWishResponses(
        //    Object.fromEntries(
        //        wishItems.map((item) => [item.id, item.message])
        //    )
        //);
        setWishResponses({});
        setSelectedWishIds(wishItems.map((item) => item.id));
    };




    const handleWishSend = () => {
        if (sending) return;

        const selectedItems = wishItems.filter(
            (item) =>
                item?.id != null &&
                selectedWishIds.includes(item.id) &&
                item.isAllowRespond
        );

        if (selectedItems.length === 0) {
            enqueueSnackbar("Please select at least one celebration.", {
                variant: "error",
            });
            return;
        }

        // Validate that every selected wish has a message
        const hasEmptyMessage = selectedItems.some(
            (item) => !safeString(wishResponses[item.id]).trim()
        );

        if (hasEmptyMessage) {
            enqueueSnackbar("Please enter your wishes before sending.", {
                variant: "error",
            });
            return;
        }

        if (!userId) {
            enqueueSnackbar("Unable to identify the logged-in user.", {
                variant: "error",
            });
            return;
        }

        setSending(true);

        Promise.all(
            selectedItems.map((item) => {
                const message = safeString(wishResponses[item.id]).trim();

                return URLS.saveEventResponse({
                    EventNotificationMasterId: item.id,
                    RespondedBy: userId,
                    RespondedDate: Moment().format("DD-MMM-YYYY"),
                    ResponseMessage: message,
                });
            })
        )
            .then((results) => {
                const hasFailedResponse = results.some(
                    (response) =>
                        typeof response?.status === "number" &&
                        response.status >= 400
                );

                if (hasFailedResponse) {
                    throw new Error("Failed to save one or more wishes.");
                }

                enqueueSnackbar("Wishes sent successfully.", {
                    variant: "success",
                });

                setWishModalOpen(false);
                setSelectedWishIds([]);
                setWishResponses({});

                return fetchEvents();
            })
            .catch((error) => {
                console.error("Error saving wishes:", error);

                enqueueSnackbar("Failed to send wishes.", {
                    variant: "error",
                });
            })
            .finally(() => setSending(false));
    };


    const handleCelebrationOpen = (event) => {
        setEventAnchor(event.currentTarget)
        setCelebrationTab(showWishesTab ? "wishes" : "today");
        fetchEvents();
    };

    const handleCelebrationClose = () => setEventAnchor(null);

    const handleDateClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleCloseDate = () => {
        setAnchorEl(null);

        const formattedDate = format(startOfMonth(new Date()), "dd-MMM-yyyy");
        fetchAttendanceReport(formattedDate);
    };
    // Modal
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handelCancel = () => {
        navigate('/login', { relpace: true });
    }
    const fetchAttendanceReport = (monthStartDate) => {
        const payload = {
            LoginUserId: CurrentLoggedInUser.ExecutiveId,
            Date: monthStartDate, // send start of month
            DisplayFor: 0,
            Output: 0
        };

        URLS.getAttendanceReport(payload)
            .then((response) => {
                if (response.status === 200) {
                    setAttendanceData(response.data);
                }
            })
            .catch(error => {
                console.log("Error", error);
            });
    };
    const handleMonthChange = (newMonth) => {
        const firstDay = startOfMonth(newMonth);
        setCurrentMonth(firstDay);
        fetchAttendanceReport(format(firstDay, "dd-MMM-yyyy"));
    };

    const onChangeMark = () => {
        console.log("hii")
        const PayloadAttendance = {
            'userDetails': [
                {
                    ContactId: userId, Lat: '0', Long: '0'

                }
            ]
        };
        console.log("PayloadAttendance", PayloadAttendance);
        URLS.postaddAttendance(PayloadAttendance)
            .then((response) => {
                console.log("ssds");
                setMark(true);
            }).catch(error => {
                // On error
                console.log(" Error ");
            });

    }

    const handleAcknowledgeClick = (event) => {
        setNotificationAnchor(event.currentTarget)
    }
    const handleCloseAcknowledge = () => {
        setNotificationAnchor(null)
    }
    const handleAcknowledgeOpenModal = (item) => {
        console.log("item", item)
        handleCloseAcknowledge();
        setAcknowledgeModal(true);
        URLS.getIssueAcknowledgementDetails({ IssueId: item })
            .then((res) => {
                if (res.status === 200) {
                    const { data } = res
                    setSelectedItem(data[0])
                    handleModalReset();
                } else {
                    enqueueSnackbar("Failed to load acknowledgement form.", { variant: "error" });
                }
            })
            .catch(() => {
                // enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);
            });
    };
    console.log("item", selectedItem)

    const handleAcknowledgeCloseModal = () => {
        setAcknowledgeModal(false);
        setSelectedItem(null);
    };

    const handleTentativeDate = (newValue) => {
        setTentativeDate(newValue);
    };

    const handleTentativeTime = (e) => {
        const value = e.target.value;

        // allow only numbers and :
        if (!/^[0-9:]*$/.test(value)) return;

        setTentativeTime(value);
    };

    const handleTentativeBlur = () => {
        if (/^\d+$/.test(tentativeTime)) {
            setTentativeTime(`${tentativeTime}:00`);
        }
    };

    const handleTimeRequired = (e) => {
        const value = e.target.value;

        // allow only numbers and :
        if (!/^[0-9:]*$/.test(value)) return;

        setTimeRequrired(value);
    };
    const handleTimeBlur = () => {
        if (/^\d+$/.test(timeRequrired)) {
            setTimeRequrired(`${timeRequrired}:00`);
        }
    };
    const handleRemark = (e) => {
        setRemark(e.target.value);
    };
    const handleModalReset = () => {
        setTentativeDate("");
        setTentativeTime("");
        setTimeRequrired("");
        setRemark("");
    };
    const handleModalSave = () => {
        if (!tentativeDate) {
            enqueueSnackbar("Tentative date is required.", { variant: "error" });
            return;
        }

        if (!tentativeTime) {
            enqueueSnackbar("Tentative time is required.", { variant: "error" });
            return;
        }

        if (!timeRequrired) {
            enqueueSnackbar("Estimated time is required.", { variant: "error" });
            return;
        }
        const actionDateTime = tentativeDate && tentativeTime
            ? `${Moment(tentativeDate).format('DD-MMM-YYYY')} ${tentativeTime}`
            : "";

        const payload = {
            IssueId: selectedItem?.IssueId,
            ActionDateTime: actionDateTime,
            EstimatedTime: String(timeRequrired) || "0",
            Remark: remark || '',
            LoginId: userId
        };
        console.log("payload", payload, tentativeTime)
        URLS.saveIssueAcknowledgement(payload)
            .then((res) => {
                if (res.status === 200) {
                    enqueueSnackbar("Acknowledgement form saved successfully.", { variant: "success" });
                    window.dispatchEvent(new Event("acknowledgementUpdated")); //  trigger loadIssueAcknowledgement api
                    handleModalReset();
                    setAcknowledgeModal(false);
                } else {
                    enqueueSnackbar("Failed to save acknowledgement form.", { variant: "error" });
                }
            })
            .catch(() => {
                // enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);
            });
    }

    const handleLogOut = () => {
        navigate('/login', { relpace: true });
    };


    const groupedIssues = [
        {
            IssueStatus: "0",
            title: "Pending Acknowledgements",
            ids: (acknowledgeData || [])
                .filter(x => x.IssueStatus === "0")
                .map(x => x.IssueId)
        },
        {
            IssueStatus: "1",
            title: "New Allocated Issue",
            ids: (acknowledgeData || [])
                .filter(x => x.IssueStatus === "1")
                .map(x => x.IssueId)
        }
    ].filter(x => x.ids.length > 0);

    console.log("timeRequrired", timeRequrired)
    useEffect(() => {
        // if (isOpenSidebar) {
        //  onCloseSidebar();
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setDashboardusername(CurrentLoggedInUser.ExecutiveName);
        setUserId(CurrentLoggedInUser.ExecutiveId);
        setIsSaplUser(CurrentLoggedInUser.IsSaplUser)
        const ContactId = CurrentLoggedInUser.ExecutiveId;
        URLS.getAttendance(ContactId)
            .then((response) => {
                console.log("response.status", response.data.status);
                if (response.data.status === true) {
                    setMark(true);
                } else {
                    setMark(false);
                }


            }).catch(error => {
                // On error
                console.log(" Error ");
            });

        fetchAttendanceReport(format(currentMonth, "dd-MMM-yyyy"));

        // console.log(" SetProjects", CurrentLoggedInUser.Menus);
    }, []);

    const fetchEvents = () =>
        URLS.getNotificationData(CurrentLoggedInUser.ExecutiveId)
            .then((response) => {
                if (response.status === 200) setEventData(response.data || []);
            })
            .catch((error) => console.log("Error", error));

    const splitNameAndDept = (full = "") => {
        const match = full.match(/^(.*?)\s*\((.*)\)\s*$/);
        if (!match) return { name: full.trim(), department: "" };
        return {
            name: match[1].trim(),
            department: match[2].replace(/\s+,/g, ",").trim(), // "Development , Pune" -> "Development, Pune"
        };
    };
    useEffect(() => {
        fetchEvents();
    }, []);
    useEffect(() => {
        console.log("wishes effect, userId =", userId);

        URLS.getLoginUserResponse(CurrentLoggedInUser.ExecutiveId)
            .then((res) => {
                console.log("wishes response:", res);
                const list = Array.isArray(res.data) ? res.data : [];
                setWishesForMe(
                    list.map((w, i) => {
                        const { name, department } = splitNameAndDept(w.RespondedByName);
                        return {
                            id: `${w.RespondedByName}-${w.RespondedDate}-${i}`,
                            name,
                            department,
                            message: w.ResponseMessage,
                            date: w.RespondedDate,
                        };
                    })
                );
            })
            .catch((err) => {
                console.error("wishes error:", err);
                setWishesForMe([]);
            });
    }, [CurrentLoggedInUser.ExecutiveId]);
    console.log("wishesForMe:", wishesForMe.length, "showWishesTab:", showWishesTab);
    const totalWFODays = new Set(
        (attendanceData || []).map(item => item?.PunchDate)
    ).size;

    return (
        <RootStyle sx={{ width: { md: `calc(100% - ${dwidth}px)` } }}>
            <ToolbarStyle>
                {/* {<IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}> */}
                {!openNav && (<IconButton onClick={onOpenSidebar} sx={{ color: '#4e342e' }}>
                    <Iconify icon="bx:menu" />
                </IconButton>)}

                {!openNav && (
                    <Box component="img" src="/static/illustrations/TikeTicLOGO.png" sx={{
                        width: 95, height: 46
                    }} />
                )}
                <Box sx={{ flexGrow: 1 }} />
                {Array.isArray(eventData) && eventData.length > 0 && (
                    <Box sx={{ position: "relative", display: "inline-block", mr: 2, ml: 1 }}>
                        <Tooltip title="Celebration">
                            <IconButton onClick={handleCelebrationOpen}>
                                <Icon
                                    icon="material-symbols:featured-seasonal-and-gifts-rounded"
                                    width={24}
                                    height={24}
                                    color={showWishesTab ? "#C54201" : "#374151"}
                                />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
                <Menu
                    anchorEl={eventAnchor}
                    open={openCelebrations}
                    onClose={handleCelebrationClose}
                    MenuListProps={{ disablePadding: true }}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}

                >
                    <Box sx={{ display: "flex", flexDirection: "column", width: 380, maxWidth: "calc(100vw - 32px)", maxHeight: 460, overflow: "hidden", }}>
                        {/* Header */}
                        <Box
                            sx={{
                                bgcolor: "#fff",
                                borderBottom: "1px solid #E8E8E8",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                px: 2,
                            }}
                        >
                            <Typography variant="h6" fontWeight={600}>
                                {showWishesTab
                                    ? myEvent?.EventName?.toLowerCase() === "special event"
                                        ? myEvent?.EventMessage
                                        : `🎉 Happy ${myEvent?.EventName || "Celebration"} ${myEvent?.ExecutiveName || ""}!`
                                    : "Today’s Celebrations"}
                            </Typography>
                            <IconButton onClick={handleCelebrationClose} aria-label="Close">
                                <CloseIcon sx={{ color: "#626165", width: 24, height: 24 }} />
                            </IconButton>
                        </Box>

                        {/* Tabs: only on my birthday */}
                        {showWishesTab && (
                            <Box sx={{ px: 2, py: 1.5 }}>
                                <Box sx={{ display: "flex", bgcolor: "#F3F4F6", borderRadius: "10px", p: 0.5 }}>
                                    {[
                                        { key: "today", label: "Today’s Celebration" },
                                        { key: "wishes", label: `Wishes For Me (${wishesForMe.length})` },
                                    ].map((tab) => {
                                        const active = celebrationTab === tab.key;
                                        return (
                                            <Box
                                                key={tab.key}
                                                onClick={() => setCelebrationTab(tab.key)}
                                                sx={{
                                                    flex: 1,
                                                    textAlign: "center",
                                                    py: 0.75,
                                                    cursor: "pointer",
                                                    borderRadius: "8px",
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    bgcolor: active ? "#fff" : "transparent",
                                                    color: active ? "#111827" : "#9CA3AF",
                                                    boxShadow: active ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                                                    transition: "all 0.15s",
                                                }}
                                            >
                                                {tab.label}
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        )}

                        {/* Body */}
                        <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0, }}>
                            <Box
                                sx={{
                                    height: "100%",
                                    overflowY: "auto",
                                    overflowX: "hidden",

                                }}
                            >
                                {showWishesTab && celebrationTab === "wishes" ? (
                                    /* ---------- Wishes For Me ---------- */
                                    <>
                                        {wishesForMe.length === 0 && (
                                            <Typography fontSize={13} color="#8B93A1" sx={{ p: 3, textAlign: "center" }}>
                                                No wishes yet.
                                            </Typography>
                                        )}
                                        {wishesForMe.map((w, index) => (
                                            <React.Fragment key={w.id ?? index}>
                                                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, px: 2, py: 1.5 }}>
                                                    <AccountPopover sx={{ width: 24, height: 24 }} />
                                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                                                            <Typography fontSize={12} fontWeight={500} color="#111827">
                                                                {w.name}
                                                            </Typography>
                                                            {w.department && (
                                                                <Typography fontSize={11} fontWeight={400} color="#848FA0">
                                                                    ({w.department})
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                        <Typography fontSize={12} fontWeight={500} color="#374151" sx={{ mt: 0.5, wordBreak: "break-word" }}>
                                                            {w.message}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {index < wishesForMe.length - 1 && <Divider />}
                                            </React.Fragment>
                                        ))}
                                    </>
                                ) : (
                                    /* ---------- Today's Celebration list ---------- */
                                    (Array.isArray(eventData) ? eventData : []).map((item, index) => (
                                        <React.Fragment key={item.EventId}>
                                            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, px: 2, py: 1.5 }}>
                                                <AccountPopover sx={{ width: 24, height: 24 }} />

                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                                                        <Typography fontSize={12} fontWeight={500}>
                                                            {item.EventTitle || "Celebration"}
                                                        </Typography>
                                                        <CelebrationBadge type={item.EventName} />
                                                    </Box>
                                                    <Typography fontSize={11} color="#848FA0" fontWeight={400}>

                                                        {item.EventShortMessage ? item.EventShortMessage : item.Department}
                                                    </Typography>
                                                </Box>

                                                {item.IsAllowRespond &&
                                                    normalizeName(item.ExecutiveName) !== normalizeName(myName) && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleWish(item)}
                                                            disabled={Boolean(item.ResponseId)}
                                                            aria-label="Send wish"
                                                            sx={{ mt: 0.25, "&.Mui-disabled": { opacity: 1 } }}
                                                        >
                                                            {item.ResponseId ? (
                                                                <CheckCircleIcon sx={{ color: "#2E7D32" }} />
                                                            ) : (
                                                                <RadioButtonUncheckedIcon sx={{ color: "#9CA3AF" }} />
                                                            )}
                                                        </IconButton>
                                                    )}
                                            </Box>
                                            {index < safeEventData.length - 1 && <Divider />}
                                        </React.Fragment>
                                    ))
                                )}
                            </Box>
                        </Box>

                        {/* Footer: Wish All only on the celebrations tab */}
                        {!(showWishesTab && celebrationTab === "wishes") && !hideWishButton && (
                            <Box sx={{ p: 2, borderTop: "1px solid #F1F1F1" }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    disabled={allWished}
                                    onClick={handleWishAll}
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: 600,
                                        fontSize: 16,
                                        py: 1,
                                        borderRadius: "10px",
                                        boxShadow: "none",
                                        "&.Mui-disabled": { bgcolor: "#9A9A9A", color: "#fff" },
                                    }}
                                >
                                    {eventData?.length <= 1 ? "Wish" : "Wish All"}
                                </Button>
                            </Box>
                        )}
                    </Box>
                </Menu>

                <Modal open={wishModalOpen} onClose={handleWishModalClose}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 520,
                            maxWidth: "calc(100vw - 32px)",
                            maxHeight: "80vh",
                            bgcolor: "#fff",
                            borderRadius: "12px",
                            outline: "none",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        }}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                px: 2,
                                py: 1,
                                borderBottom: "1px solid #D1D5DB",
                            }}
                        >
                            <Typography fontSize={14} fontWeight={600} >
                                Send Your Wishes!
                            </Typography>
                            <IconButton
                                onClick={handleWishModalClose}
                                aria-label="Close"
                                sx={{ bgcolor: "#F1F1F1", borderRadius: "4px", border: ' 1px solid #EDEDED' }}
                            >
                                <CloseIcon sx={{ fontSize: 20, color: "#000000" }} />
                            </IconButton>
                        </Box>

                        {/* Cards */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: "auto",
                                px: 2,
                                py: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                            }}
                        >
                            {wishItems.map((item) => {
                                const selected = selectedWishIds.includes(item.id);

                                return (
                                    <Box
                                        key={item.id}
                                        onClick={() => {
                                            setSelectedWishIds((prev) =>
                                                prev.includes(item.id)
                                                    ? prev.filter((id) => id !== item.id)
                                                    : [...prev, item.id]
                                            );
                                        }}
                                        sx={{
                                            border: "1px solid",
                                            borderColor: selected ? "#2E7D32" : "#E5E5E5",
                                            bgcolor: selected ? "#F0FDF4" : "#FFFFFF",
                                            borderRadius: "14px",
                                            p: 1.5,
                                            transition: "all 0.15s ease",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                                            <AccountPopover sx={{ width: 24, height: 24 }} />
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                                                    <Typography fontSize={12} fontWeight={500}>
                                                        {item.type === "special event"
                                                            ? item.message
                                                            : item.name}
                                                    </Typography>

                                                    <CelebrationBadge type={item.type} years={item.years} />
                                                </Box>

                                                <Typography fontSize={11} fontWeight={400} color="#848FA0">
                                                    {item.type === "special event" ? "" : item.EventName}
                                                </Typography>
                                            </Box>
                                            <Typography
                                                fontSize={11}
                                                color="#848FA0"
                                                fontWeight={400}
                                            >
                                                {item.Department}
                                            </Typography>
                                            {/* select check: only when more than one person */}

                                        </Box>
                                        <TextField
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            placeholder={getDefaultMessage(item)}
                                            value={wishResponses[item.id] ?? ""}
                                            onChange={(e) =>
                                                setWishResponses((prev) => ({
                                                    ...prev,
                                                    [item.id]: e.target.value,
                                                }))
                                            }
                                        />
                                    </Box>
                                );
                            })}
                        </Box>

                        {/* Footer */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1.5,
                                px: 2.5,
                                py: 1.5,
                                borderTop: "1px solid #E5E7EB",
                            }}
                        >
                            <Button
                                variant="outlined"
                                onClick={handleWishReset}
                                sx={{
                                    textTransform: "none",
                                    fontWeight: 500,
                                    borderRadius: "8px",
                                    color: "#374151",
                                    borderColor: "#D1D5DB",
                                    bgcolor: "#F3F4F6",
                                    "&:hover": { bgcolor: "#E5E7EB", borderColor: "#D1D5DB" },
                                }}
                            >
                                Reset
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleWishSend}
                               
                                sx={{
                                    textTransform: "none",
                                    fontWeight: 600,
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    px: 3,
                                    bgcolor: "#2E7D32",
                                    "&:hover": { bgcolor: "#256628", boxShadow: "none" },
                                }}
                            >
                                Send
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {isSaplUser && acknowledgeData?.length > 0 &&
                    (
                        <Box sx={{ position: "relative", display: "inline-block", mr: 2, ml: 1 }}>

                            <Tooltip title="Notification">
                                <Badge
                                    badgeContent={acknowledgeData.length}
                                    overlap="circular"
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            width: 20,
                                            height: 19,
                                            minWidth: 20,
                                            backgroundColor: "#E7000B",
                                            color: "#FFFFFF",
                                            boxShadow: "0px 0px 1px 0px #00000040",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            borderRadius: '6px',
                                            marginRight: '5px'
                                        },
                                    }}
                                >
                                    <NotificationsOutlinedIcon
                                        sx={{ color: "#374151", mr: 1, width: 24, height: 24, cursor: "pointer" }}
                                        onClick={handleAcknowledgeClick}
                                    />
                                </Badge>

                            </Tooltip>

                            <Menu
                                anchorEl={notificationAnchor}
                                open={openAcknowledgeList}
                                onClose={handleCloseAcknowledge}
                                MenuListProps={{ disablePadding: true }}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "center",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "center",
                                }}
                                PaperProps={{
                                    sx: {
                                        mt: "10px",
                                        width: 308,
                                        borderRadius: 1,
                                        p: 0,
                                        boxShadow: ' 0px 0px 4px 0px #00000040',
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                        backgroundColor: '#fff',
                                        borderBottom: '1px solid #D1D5DB',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        px: 2,

                                    }}
                                >
                                    <Typography variant="h6" fontWeight="600">
                                        Notification
                                    </Typography>
                                    <IconButton onClick={handleCloseAcknowledge} sx={{ color: "#626165" }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <Box sx={{ maxHeight: 340, overflowY: "auto", }}>
                                    {groupedIssues?.map((item, index) => {
                                        const count = item.ids.length;
                                        const issueText = count === 1 ? "issue" : "issues";

                                        return (
                                            <Box
                                                key={index}
                                                sx={{
                                                    px: 2,
                                                    py: 1,
                                                    cursor: "pointer",
                                                    border: index !== groupedIssues.length - 1 ? "1px solid #F1F1F1" : "none",
                                                }}
                                                onClick={handleCloseAcknowledge}
                                            >
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                        <Box
                                                            sx={{
                                                                width: 14,
                                                                height: 14,
                                                                borderRadius: "50%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                backgroundColor: item.IssueStatus === "0" ? "#FFEDEE" : "#EEF4FF",
                                                                mb: 1
                                                            }}
                                                        >
                                                            {item.IssueStatus === "0" ? (
                                                                <ErrorOutlineOutlinedIcon sx={{ color: "#E7000B", width: 10, height: 10 }} />
                                                            ) : (
                                                                <AssignmentTurnedInOutlinedIcon sx={{ color: "#3C97FF", width: 10, height: 10 }} />
                                                            )}
                                                        </Box>

                                                        <Typography fontSize={12} fontWeight={500} mb={1}>
                                                            {item.IssueStatus === "0"
                                                                ? "Pending Acknowledgements"
                                                                : "New Allocated Issue"}
                                                        </Typography>

                                                    </Box>
                                                </Box>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, flex: 1 }}>
                                                        <Typography fontSize={11} color="#848FA0" mb={1}>
                                                            {item.IssueStatus === "0"
                                                                ? `You have ${item.ids.length} ${issueText} pending on your acknowledge list. Please acknowledge this ${issueText} to set deadlines.`
                                                                : `You have ${item.ids.length} ${issueText} allocated".`}
                                                        </Typography>
                                                    </Box>
                                                    {/*<Typography*/}
                                                    {/*    fontSize={11}*/}
                                                    {/*    color="#848FA0"*/}
                                                    {/*    sx={{ whiteSpace: "nowrap", flexShrink: 0 }}*/}
                                                    {/*>*/}
                                                    {/*    {item.time}*/}
                                                    {/*</Typography>*/}
                                                </Box>
                                                <Typography fontSize={10} fontWeight={500} color="#666060">
                                                    Issue IDs:
                                                </Typography>

                                                <Box sx={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(4, auto)", gap: 0.5, mt: 0.5,
                                                }}>
                                                    {(item.ids || []).map((id) => (
                                                        <Box
                                                            key={id}
                                                            sx={{
                                                                px: 1.5,
                                                                py: 0.5,
                                                                borderRadius: "6px",
                                                                fontSize: "10px",
                                                                fontWeight: 500,
                                                                backgroundColor: item.IssueStatus === "0" ? "#FFF6F6" : "#F6F9FF",
                                                                color: item.IssueStatus === "0" ? "#E7000B" : "#0062FF",

                                                            }}
                                                            onClick={(e) => {
                                                                console.log("Clicked:", item);
                                                                setNotificationAnchor(null);
                                                                e.stopPropagation(); // prevent the parent Box onClick
                                                                handleAcknowledgeOpenModal(id);
                                                            }}
                                                        >
                                                            {id}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>

                            </Menu>

                        </Box>
                    )
                }

                <Modal open={acknowledgeModal} onClose={handleAcknowledgeCloseModal}>
                    <Box
                        sx={{
                            ...modalStyle,
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                        }}
                    >
                        {/* Sticky Header */}
                        <Box
                            sx={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                                backgroundColor: '#fff',
                                borderBottom: '1px solid #D1D5DB',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                px: 2,
                            }}
                        >
                            <Typography variant="h6" fontWeight="600">
                                Acknowledge
                            </Typography>
                            <IconButton onClick={handleAcknowledgeCloseModal}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {/* Scrollable Content */}
                        <Box
                            sx={{
                                display: 'flex',
                                flex: 1,
                                overflow: 'hidden',
                            }}
                        >
                            {/* Left Panel */}
                            <Box
                                sx={{
                                    flex: 4.5,
                                    backgroundColor: '#fff',
                                    borderRight: '1px solid #E0E0E0',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflowY: 'auto',
                                }}
                            >
                                <Box sx={{ px: 2, py: 1 }}>
                                    <Typography fontSize={14} fontWeight={500}>
                                        Issue Information
                                    </Typography>
                                </Box>

                                {selectedItem && (
                                    <Box sx={{ px: 3, pb: 2 }}>
                                        <Typography fontSize={12}>
                                            <Box component="span" sx={{ color: '#FC3838', fontWeight: 600 }}>
                                                {selectedItem.IssueId}
                                            </Box>
                                            {" - "}
                                            <Box component="span" sx={{ fontWeight: 500 }}>
                                                {selectedItem.ProjectName} : {selectedItem.IssueCategory}
                                            </Box>
                                        </Typography>

                                        <Box sx={{ mt: 1 }}>
                                            <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                                Client/Site:
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {selectedItem.ClientName} : {selectedItem.SiteName}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ mt: 1 }}>
                                            <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                                Allocated by:
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {selectedItem.Name}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ mt: 1 }}>
                                            <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                                Last remark:
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {stripHtml(selectedItem?.ServiceProvided)}

                                            </Typography>
                                        </Box>

                                        <Box sx={{ mt: 1 }}>
                                            <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }} >
                                                Issue remark:
                                            </Typography>
                                            <Typography variant="body2" color="text.primary" >
                                                {stripHtml(selectedItem?.IssueRemark)}
                                            </Typography>

                                        </Box>
                                    </Box>
                                )}
                            </Box>

                            {/* Right Panel: Acknowledge Form */}
                            <Box
                                sx={{
                                    flex: 5.5,
                                    overflowY: 'auto',
                                    backgroundColor: '#fff',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                {/* SCROLLABLE CONTENT WITH PADDING */}
                                <Box sx={{ py: 1, px: 2, flex: 1 }}>

                                    <Typography fontSize={14} fontWeight={500}>
                                        Acknowledge Form{" "}
                                        {selectedItem?.DelayedTime && (
                                            <Typography
                                                component="span"
                                                sx={{ fontSize: 12, fontWeight: 500, color: "#FF2B2B" }}
                                            >
                                                (Delayed: {selectedItem.DelayedTime})
                                            </Typography>
                                        )}
                                    </Typography>
                                    {/* tentative Date */}
                                    <Box>
                                        {/* Date & Time Row */}
                                        <Box display="flex" alignItems="center" gap={2} mt={1}>
                                            <FormControl size="small" fullWidth sx={{ mb: 1 }}>
                                                <FormLabel>Tentative Action Date</FormLabel>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DesktopDatePicker
                                                        inputFormat="dd/MMM/yyyy"
                                                        value={tentativeDate ? Moment(tentativeDate, 'DD-MMM-YYYY').toDate() : null}
                                                        onChange={handleTentativeDate}
                                                        renderInput={(params) => (
                                                            <TextField fullWidth size="small" {...params} error={false} />
                                                        )}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>

                                            <FormControl size="small" fullWidth sx={{ mb: 1 }}>
                                                <FormLabel>Tentative Action Time</FormLabel>
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    value={tentativeTime}
                                                    onChange={handleTentativeTime}
                                                    onBlur={handleTentativeBlur}
                                                    placeholder="HH:MM"
                                                />
                                            </FormControl>
                                        </Box>

                                        {/* Warning Text Below */}
                                        <Typography fontSize={10} fontWeight={500} color="#FF2B2B" sx={{ mb: 2 }}>
                                            Issue will move to "Acknowledgement Pending" if this deadline passes
                                        </Typography>
                                    </Box>

                                    <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                                        <FormLabel>Tentative Time Required</FormLabel>

                                        <TextField
                                            value={timeRequrired}
                                            onChange={handleTimeRequired}
                                            onBlur={handleTimeBlur}
                                            placeholder="HH:MM"
                                            size="small"
                                            fullWidth
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                                        <FormLabel>Remark</FormLabel>
                                        <TextareaAutosize
                                            minRows={3}
                                            placeholder="Add any comment..."
                                            value={remark} // replace with state
                                            onChange={handleRemark} // replace with handler
                                            style={{
                                                width: '100%',
                                                resize: 'none',
                                                border: '1px solid #E5E5E5',
                                                borderRadius: 4,
                                                padding: 8,
                                            }}
                                        />
                                    </FormControl>
                                </Box>

                                <Box sx={{ backgroundColor: "#fff", p: 2 }}>

                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                        <Tooltip title="Reset">

                                            <Button variant="outlined" sx={{ width: '130px', height: '40px', color: '#374151' }} onClick={handleModalReset}>Reset</Button>
                                        </Tooltip >

                                        <Tooltip title="Save">
                                            <LoadingButton
                                                size="medium"
                                                type="submit"
                                                variant="contained"
                                                sx={{ width: '130px', height: '40px' }}
                                                onClick={handleModalSave}

                                            >
                                                Save
                                            </LoadingButton>
                                        </Tooltip >
                                    </Stack>
                                </Box>

                            </Box>

                        </Box>
                    </Box>
                </Modal >

                {isSaplUser &&
                    (
                        <Box sx={{ position: "relative", display: "inline-block", }}>

                            {/* Calendar Icon with Badge */}
                            <Tooltip title="Work From Office Days">
                                <Badge
                                    badgeContent={totalWFODays}
                                    overlap="circular"
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            width: 20,
                                            height: 19,
                                            minWidth: 20,
                                            backgroundColor: "#78C043",
                                            color: "#FFFFFF",
                                            boxShadow: "0px 0px 1px 0px #00000040",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            borderRadius: '6px',
                                            marginRight: '2px'
                                        },
                                    }}
                                >
                                    <CalendarMonthOutlinedIcon
                                        sx={{ color: "#374151", mr: 1, width: 24, height: 24, cursor: "pointer" }}
                                        onClick={handleDateClick}
                                    />
                                </Badge>
                            </Tooltip>

                            {/* Calendar Popover */}
                            {openDateBox && (
                                <Menu
                                    anchorEl={anchorEl}
                                    open={openDateBox}
                                    onClose={handleCloseDate}
                                    MenuListProps={{ disablePadding: true }}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                    }}
                                    PaperProps={{
                                        sx: {
                                            p: 1,
                                            borderRadius: '10px',
                                            mt: "10px",
                                            boxShadow: "0px 0px 4px 0px #00000040",

                                        }
                                    }}
                                >
                                    {/* HEADER */}
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 1 }}>
                                        <Typography sx={{ fontWeight: 500, fontSize: "12px", color: "#121212" }}>
                                            Total Work From Office
                                        </Typography>
                                        <Box sx={{
                                            backgroundColor: "#78C043",
                                            color: "#fff",
                                            px: 1.5, py: 0.5, borderRadius: "12px",
                                            fontSize: "12px", fontWeight: 500
                                        }}>
                                            {totalWFODays} {totalWFODays === 1 ? "Day" : "Days"}
                                        </Box>
                                    </Box>

                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Box sx={{ height: 285, border: "1px solid #F0F0F0", overflow: "hidden" }}>
                                            <Box
                                                sx={{
                                                    transform: "scale(0.90)",
                                                    transformOrigin: "top left",
                                                    width: 285
                                                }}
                                            >
                                                <CalendarPicker
                                                    date={date}
                                                    onChange={(newDate) => setDate(newDate)}
                                                    disableFuture
                                                    onMonthChange={handleMonthChange}
                                                    renderDay={(day, _selectedDates, pickersDayProps) => {
                                                        const monthMap = {
                                                            Jan: 0, Feb: 1, Mar: 2, Apr: 3,
                                                            May: 4, Jun: 5, Jul: 6, Aug: 7,
                                                            Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                                                        };

                                                        const dayPunches = (attendanceData || [])
                                                            .filter(item => {
                                                                if (!item?.PunchDate) return false;

                                                                const [year, month, date] = item.PunchDate.split("-");

                                                                const monthMap = {
                                                                    Jan: 0, Feb: 1, Mar: 2, Apr: 3,
                                                                    May: 4, Jun: 5, Jul: 6, Aug: 7,
                                                                    Sep: 8, Oct: 9, Nov: 10, Dec: 11,
                                                                };

                                                                return (
                                                                    Number(year) === day.getFullYear() &&
                                                                    monthMap[month] === day.getMonth() &&
                                                                    Number(date) === day.getDate()
                                                                );
                                                            })
                                                            .flatMap(item =>
                                                                (item.PunchTime || "")
                                                                    .split(",")
                                                                    .map(t => t.trim())
                                                            )
                                                            .sort((a, b) => b.localeCompare(a)); // descending time

                                                        const isPunchDay = dayPunches.length > 0;

                                                        const today = new Date();
                                                        const isToday =
                                                            today.getFullYear() === day.getFullYear() &&
                                                            today.getMonth() === day.getMonth() &&
                                                            today.getDate() === day.getDate();

                                                        return (
                                                            <Tooltip

                                                                title={
                                                                    dayPunches.length > 0 ? (
                                                                        <div>
                                                                            {/*{dayPunches.map((time, index) => (*/}
                                                                            {/*    <div key={index}>{time}</div>*/}
                                                                            {/*))}*/}
                                                                            {dayPunches.map((time, index) => {
                                                                                const isManual = time.includes("(M)");

                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        style={{
                                                                                            color: isManual ? "#9A9A9A" : "#FFFFFF",
                                                                                        }}
                                                                                    >
                                                                                        {time.replace(" (M)", "")}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    ) : null
                                                                }
                                                            >
                                                                <span>
                                                                    <PickersDay
                                                                        {...pickersDayProps}
                                                                        disabled
                                                                        sx={{
                                                                            borderRadius: 1,

                                                                            ...(isPunchDay && {
                                                                                bgcolor: "#E8FEE1 !important",
                                                                                color: "#48BE1D !important",
                                                                            }),

                                                                            ...(isToday &&
                                                                                !pickersDayProps.selected && {
                                                                                border: "1px solid #00A63E !important",
                                                                            }),
                                                                        }}
                                                                    />
                                                                </span>
                                                            </Tooltip>
                                                        );
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </LocalizationProvider>

                                    {/* Footer */}
                                    <Box sx={{ p: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: 5 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Box sx={{ width: 20, height: 16, bgcolor: "#E8FEE1", borderRadius: "5px" }} />
                                            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>Work From Office</Typography>
                                        </Box>

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                            <Box sx={{ width: 20, height: 16, border: "1px solid #00A63E", borderRadius: "5px" }} />
                                            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>Today</Typography>
                                        </Box>
                                    </Box>
                                </Menu>

                            )}
                        </Box>
                    )}


                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{ mx: 2, color: '#E5E7EB' }}  // space around divider
                />
                <AccountPopover />

                <Typography variant="subtitle1" sx={{ color: '#000000', ml: 1, mr: 2 }}>
                    {username}
                </Typography>
                <Tooltip title="Log out">
                    <IconButton onClick={handleOpen}
                        sx={{
                            color: '#E7000B',
                            // ":hover": {
                            //    cursor: "pointer",
                            //    color: "#FB0000",

                            // },
                        }}
                    >
                        <Icon icon="material-symbols:power-settings-circle-outline" width={24} height={24} />
                    </IconButton>
                </Tooltip>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" sx={{ mb: 2, textAlign: 'center' }} gutterBottom>
                            Confirm Logout?
                        </Typography>
                        <Stack direction="row" justifyContent="center" alignItems="center" spacing={3}>

                            <Button
                                onClick={handelCancel}
                                size="small"
                                variant="contained"
                            >
                                Yes
                            </Button>
                            <Button
                                onClick={handleClose}
                                size="small"
                                variant="contained"
                            >
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>
                {isSaplUser && (
                    mark === true ?
                        <Tooltip title="I am present">
                            <IconButton onClick={onChangeMark} value={mark}
                                /* 64dd17 */
                                sx={{ color: '#64dd17' }}

                            >

                                <Icon icon="ic:twotone-fingerprint" width={24} height={24} />
                            </IconButton></Tooltip> :

                        <IconButton onClick={onChangeMark} value={mark}
                            sx={{
                                // color: '#B50000',
                                color: '#E7000B',
                                ":hover": {
                                    cursor: "pointer",
                                    color: "#FB0000",

                                },
                            }}>

                            <Icon icon="ic:twotone-fingerprint" width={24} height={24} />
                        </IconButton>
                )}
            </ToolbarStyle>
        </RootStyle>
    );
}
